import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-button',
  styleUrl: 'lab-ds-button.css',
  shadow: true,
})
export class LabDsButton {
  @Event() handleButton: EventEmitter;

  handleClick() {
    this.handleButton.emit();
  }

  @Prop() size: 'small' | 'medium' | 'large' = 'medium';

  @Prop() type: 'button' | 'submit' = 'button';

  @Prop() variant: 'primary' | 'outlined' | 'link-button' | 'cta' | 'danger-primary' | 'danger-outlined' = 'primary';

  @Prop() disabled: boolean;

  @Prop() loading: boolean;

  @Prop() leadingIcon: string;

  @Prop() stepIcon: string;

  @Prop() label: string;

  @Prop() maxWidth: boolean = false;

  render() {
    return (
      <button
        disabled={this.disabled || this.loading}
        onClick={() => this.handleClick()}
        type={this.type}
        class={`button ${this.maxWidth ? 'max-width' : ''} ${this.variant} ${this.size} ${this.loading && 'loading'}`}
      >
        <span class="label">
          {this.leadingIcon && <lab-ds-icon-not-selectable class="leading-icon" size={this.size === 'large' ? 's-medium' : 'small'} icon={this.leadingIcon} />}
          {this.label && <span class="label-text">{this.label}</span>}
          {this.stepIcon && <lab-ds-icon-not-selectable class="step-icon" size={this.size === 'large' ? 's-medium' : 'small'} icon={this.stepIcon} />}
        </span>
        <div class="icon-loading">
          <span class="material-symbols-outlined icon">progress_activity</span>
        </div>
      </button>
    );
  }
}
